module.exports = __webpack_public_path__ + "img/hospital.3cb4f94c.svg";